import Paginator from '@/models/Paginator'
import { common as commonBackend } from '@/api'

export default {

  namespaced: true,

  state: {
    requests: new Paginator,
    count: 0
  },

  mutations: {
    setRequests: (state, payload) => state.requests = payload,
    setCount: (state, payload) => state.count = payload,
  },

  actions: {
    loadRequests: ({commit}, path) => new Promise((resolve, reject) => {
      commonBackend.loadPath(path, response => {
        commit('setRequests', response.data)
        resolve()
      }, reject)
    }),
    countRequests: ({ commit }) => new Promise((resolve, reject) => {
      commonBackend.loadPath({
        path: '/connection-requests/count'
      }, response => {
        commit('setCount', response.data.pending)
        resolve()
      }, reject)
    })
  },

  getters: {
    requests: state => state.requests
  }

}
